// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --jvm-border-color: #E5E6E7;
  --jvm-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --jvm-tooltip-font-size: 0.9rem;
  --jvm-tooltip-bg-color: #337FFA;
  --jvm-tooltip-color: #FFF;
  --jvm-tooltip-padding: 3px 5px;
  --jvm-tooltip-shadow: var(--jvm-box-shadow);
  --jvm-tooltip-radius: 3px;
  --jvm-zoom-btn-bg-color: #292929;
  --jvm-zoom-btn-color: #FFF;
  --jvm-zoom-btn-size: 15px;
  --jvm-zoom-btn-radius: 3px;
  --jvm-series-container-right: 15px;
  --jvm-legend-bg-color: #FFF;
  --jvm-legend-radius: 0.15rem;
  --jvm-legend-margin-left: 0.75rem;
  --jvm-legend-padding: 0.6rem;
  --jvm-legend-title-padding-bottom: 0.5rem;
  --jvm-legend-title-margin-bottom: 0.575rem;
  --jvm-legend-tick-margin-top: 0.575rem;
  --jvm-legend-tick-sample-radius: 0;
  --jvm-legend-tick-sample-height: 12px;
  --jvm-legend-tick-sample-width: 30px;
  --jvm-legend-tick-text-font-size: 12px;
  --jvm-legend-tick-text-margin-top: 3px;
}

image, text, .jvm-zoom-btn {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.jvm-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.jvm-tooltip {
  border-radius: var(--jvm-tooltip-radius);
  background-color: var(--jvm-tooltip-bg-color);
  color: var(--jvm-tooltip-color);
  font-size: var(--jvm-tooltip-font-size);
  box-shadow: var(--jvm-tooltip-shadow);
  padding: var(--jvm-tooltip-padding);
  white-space: nowrap;
  position: absolute;
  display: none;
}
.jvm-tooltip.active {
  display: block;
}

.jvm-zoom-btn {
  background-color: var(--jvm-zoom-btn-bg-color);
  color: var(--jvm-zoom-btn-color);
  border-radius: var(--jvm-zoom-btn-radius);
  height: var(--jvm-zoom-btn-size);
  width: var(--jvm-zoom-btn-size);
  box-sizing: border-box;
  position: absolute;
  left: 10px;
  line-height: var(--jvm-zoom-btn-size);
  text-align: center;
  cursor: pointer;
}
.jvm-zoom-btn.jvm-zoomin {
  top: var(--jvm-zoom-btn-size);
}
.jvm-zoom-btn.jvm-zoomout {
  top: calc(var(--jvm-zoom-btn-size) * 2 + var(--jvm-zoom-btn-size) / 3);
}

.jvm-series-container {
  position: absolute;
  right: var(--jvm-series-container-right);
}
.jvm-series-container.jvm-series-h {
  bottom: 15px;
}
.jvm-series-container.jvm-series-v {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
      flex-direction: column;
  gap: 0.75rem;
  top: 15px;
}

.jvm-legend {
  background-color: var(--jvm-legend-bg-color);
  border: 1px solid var(--jvm-border-color);
  margin-left: var(--jvm-legend-margin-left);
  border-radius: var(--jvm-legend-radius);
  padding: var(--jvm-legend-padding);
  box-shadow: var(--jvm-box-shadow);
}

.jvm-legend-title {
  line-height: 1;
  border-bottom: 1px solid var(--jvm-border-color);
  padding-bottom: var(--jvm-legend-title-padding-bottom);
  margin-bottom: var(--jvm-legend-title-margin-bottom);
  text-align: left;
}

.jvm-legend-tick {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
      align-items: center;
  min-width: 40px;
}
.jvm-legend-tick:not(:first-child) {
  margin-top: var(--jvm-legend-tick-margin-top);
}

.jvm-legend-tick-sample {
  border-radius: var(--jvm-legend-tick-sample-radius);
  margin-right: 0.45rem;
  height: var(--jvm-legend-tick-sample-height);
  width: var(--jvm-legend-tick-sample-width);
}

.jvm-legend-tick-text {
  font-size: var(--jvm-legend-tick-text-font-size);
  text-align: center;
  line-height: 1;
}

.jvm-line[animation=true] {
  -webkit-animation: jvm-line-animation 10s linear forwards infinite;
  animation: jvm-line-animation 10s linear forwards infinite;
}
@-webkit-keyframes jvm-line-animation {
  from {
    stroke-dashoffset: 250;
  }
}
@keyframes jvm-line-animation {
  from {
    stroke-dashoffset: 250;
  }
}`, "",{"version":3,"sources":["webpack://./../node_modules/jsvectormap/dist/jsvectormap.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,8BAA8B;EAC9B,2CAA2C;EAC3C,yBAAyB;EACzB,gCAAgC;EAChC,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;EAC5B,iCAAiC;EACjC,4BAA4B;EAC5B,yCAAyC;EACzC,0CAA0C;EAC1C,sCAAsC;EACtC,kCAAkC;EAClC,qCAAqC;EACrC,oCAAoC;EACpC,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;EAC7C,+BAA+B;EAC/B,uCAAuC;EACvC,qCAAqC;EACrC,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,yCAAyC;EACzC,gCAAgC;EAChC,+BAA+B;EAC/B,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sEAAsE;AACxE;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,0BAA0B;MACtB,sBAAsB;EAC1B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,0CAA0C;EAC1C,uCAAuC;EACvC,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gDAAgD;EAChD,sDAAsD;EACtD,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;MAClB,mBAAmB;EACvB,eAAe;AACjB;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mDAAmD;EACnD,qBAAqB;EACrB,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,0DAA0D;AAC5D;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[":root {\n  --jvm-border-color: #E5E6E7;\n  --jvm-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --jvm-tooltip-font-size: 0.9rem;\n  --jvm-tooltip-bg-color: #337FFA;\n  --jvm-tooltip-color: #FFF;\n  --jvm-tooltip-padding: 3px 5px;\n  --jvm-tooltip-shadow: var(--jvm-box-shadow);\n  --jvm-tooltip-radius: 3px;\n  --jvm-zoom-btn-bg-color: #292929;\n  --jvm-zoom-btn-color: #FFF;\n  --jvm-zoom-btn-size: 15px;\n  --jvm-zoom-btn-radius: 3px;\n  --jvm-series-container-right: 15px;\n  --jvm-legend-bg-color: #FFF;\n  --jvm-legend-radius: 0.15rem;\n  --jvm-legend-margin-left: 0.75rem;\n  --jvm-legend-padding: 0.6rem;\n  --jvm-legend-title-padding-bottom: 0.5rem;\n  --jvm-legend-title-margin-bottom: 0.575rem;\n  --jvm-legend-tick-margin-top: 0.575rem;\n  --jvm-legend-tick-sample-radius: 0;\n  --jvm-legend-tick-sample-height: 12px;\n  --jvm-legend-tick-sample-width: 30px;\n  --jvm-legend-tick-text-font-size: 12px;\n  --jvm-legend-tick-text-margin-top: 3px;\n}\n\nimage, text, .jvm-zoom-btn {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.jvm-container {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n\n.jvm-tooltip {\n  border-radius: var(--jvm-tooltip-radius);\n  background-color: var(--jvm-tooltip-bg-color);\n  color: var(--jvm-tooltip-color);\n  font-size: var(--jvm-tooltip-font-size);\n  box-shadow: var(--jvm-tooltip-shadow);\n  padding: var(--jvm-tooltip-padding);\n  white-space: nowrap;\n  position: absolute;\n  display: none;\n}\n.jvm-tooltip.active {\n  display: block;\n}\n\n.jvm-zoom-btn {\n  background-color: var(--jvm-zoom-btn-bg-color);\n  color: var(--jvm-zoom-btn-color);\n  border-radius: var(--jvm-zoom-btn-radius);\n  height: var(--jvm-zoom-btn-size);\n  width: var(--jvm-zoom-btn-size);\n  box-sizing: border-box;\n  position: absolute;\n  left: 10px;\n  line-height: var(--jvm-zoom-btn-size);\n  text-align: center;\n  cursor: pointer;\n}\n.jvm-zoom-btn.jvm-zoomin {\n  top: var(--jvm-zoom-btn-size);\n}\n.jvm-zoom-btn.jvm-zoomout {\n  top: calc(var(--jvm-zoom-btn-size) * 2 + var(--jvm-zoom-btn-size) / 3);\n}\n\n.jvm-series-container {\n  position: absolute;\n  right: var(--jvm-series-container-right);\n}\n.jvm-series-container.jvm-series-h {\n  bottom: 15px;\n}\n.jvm-series-container.jvm-series-v {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 0.75rem;\n  top: 15px;\n}\n\n.jvm-legend {\n  background-color: var(--jvm-legend-bg-color);\n  border: 1px solid var(--jvm-border-color);\n  margin-left: var(--jvm-legend-margin-left);\n  border-radius: var(--jvm-legend-radius);\n  padding: var(--jvm-legend-padding);\n  box-shadow: var(--jvm-box-shadow);\n}\n\n.jvm-legend-title {\n  line-height: 1;\n  border-bottom: 1px solid var(--jvm-border-color);\n  padding-bottom: var(--jvm-legend-title-padding-bottom);\n  margin-bottom: var(--jvm-legend-title-margin-bottom);\n  text-align: left;\n}\n\n.jvm-legend-tick {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-width: 40px;\n}\n.jvm-legend-tick:not(:first-child) {\n  margin-top: var(--jvm-legend-tick-margin-top);\n}\n\n.jvm-legend-tick-sample {\n  border-radius: var(--jvm-legend-tick-sample-radius);\n  margin-right: 0.45rem;\n  height: var(--jvm-legend-tick-sample-height);\n  width: var(--jvm-legend-tick-sample-width);\n}\n\n.jvm-legend-tick-text {\n  font-size: var(--jvm-legend-tick-text-font-size);\n  text-align: center;\n  line-height: 1;\n}\n\n.jvm-line[animation=true] {\n  -webkit-animation: jvm-line-animation 10s linear forwards infinite;\n  animation: jvm-line-animation 10s linear forwards infinite;\n}\n@-webkit-keyframes jvm-line-animation {\n  from {\n    stroke-dashoffset: 250;\n  }\n}\n@keyframes jvm-line-animation {\n  from {\n    stroke-dashoffset: 250;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
